const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.REACT_APP_NODE_ENV === "development"
    ? "http://localhost:8000/api"
    : "/api");

export const getPaintings = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/paintings`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error("Received non-JSON response");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching paintings:", error);
    throw error;
  }
};
